module.exports = __webpack_public_path__ + "static/media/load.6f401e04.svg";